/**
 * Arabic with English in one line (Aziz's team, 2026-09-28). The browser orders a mixed
 * line by its first strong letter; an Arabic line that ends on an English phrase then
 * throws the phrase's full stop to the far side (".world" instead of "world."). A
 * left-to-right mark after that punctuation keeps it with the English words. Display
 * only: never applied to text a person is editing.
 *
 * Pair it with `dir="auto"` and BIDI_CLS on the element, so every line (paragraph)
 * takes its own direction from its own first letter.
 */
const RTL = /[֐-ࣿיִ-﷿ﹰ-﻿]/;
const FIRST_STRONG = /[A-Za-zÀ-ɏ֐-ࣿיִ-﷿ﹰ-﻿]/;
const LRM = '‎';
const RLM = '‏';
// what a line may open with that says nothing about its language: @people, #links, web addresses
const LEAD = /^(?:\s*(?:@[\w-]+(?: [A-Z][\w-]*)?|#\[[^\]]*\]|(?:https?:\/\/|www\.)\S+)\s*)+/;

export function bidiLine(line: string): string {
  const first = line.replace(LEAD, '').match(FIRST_STRONG);
  if (!first || !RTL.test(first[0])) return line;
  // an English phrase closing an Arabic line keeps its punctuation
  let out = line.replace(/([A-Za-z0-9][.!?:;)]+)(\s*)$/, `$1${LRM}$2`);
  // "@Sami الدكتورة وافقت..." is an Arabic line: without this it is laid out left to right
  const raw = line.match(FIRST_STRONG);
  if (raw && !RTL.test(raw[0])) out = RLM + out;
  return out;
}

export function bidi(text: string | null | undefined): string {
  return (text ?? '').split('\n').map(bidiLine).join('\n');
}

/** each line takes its direction from its own first letter */
export const BIDI_CLS = '[unicode-bidi:plaintext]';
